<template>
  <v-dialog v-model="addDialog" class="the-app-dialogs" persistent max-width="800px">
    <v-card>
      <form @submit.prevent="validateBeforeSubmit()">
        <v-layout row class="no-select" style="background-color:#09132f">
          <h3 id="dialog-title" class="text-uppercase px-3 pt-3" style="text-xs-center letter-spacing:2px">
            <v-layout align-center>
              <v-icon light x-large class="rgba(0,0,0,0.3)--text pb-1">attach_money</v-icon>
              <span class="px-3">{{ $t('Add New Payroll') }}</span>
            </v-layout>
          </h3>
          <v-spacer />
          <v-card-actions>
            <v-btn fab icon dark @click="$emit('hidemodal')">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-actions>
        </v-layout>

        <v-card-title class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="headline no-select pb-1">
              <v-layout justify-end></v-layout>
            </v-flex>

            <v-layout row wrap>
              <v-flex xs4 pa-2>
                <v-menu v-model="dateModal" full-width max-width="290" :close-on-content-click="false">
                  <v-text-field
                    slot="activator"
                    :value="theDate"
                    :label="`${$t('Payroll Month')} *`"
                    prepend-inner-icon="event"
                    box
                    readonly
                    hide-details
                    name="Payroll Month"
                    background-color="white"
                    autocomplete="off"
                    :error="errors.has('Payroll Month')"
                    v-validate="'required|date_format:yyyy-LLLL'"
                  />
                  <v-date-picker @change="dateModal = false" v-model="form.the_month" />
                </v-menu>
              </v-flex>

              <v-flex xs4 pa-2>
                <v-text-field
                  id="payroll-focus-me"
                  v-model.number="form.month_incentive"
                  :label="$t('Incentive')"
                  hide-details
                  box
                  data-vv-name="Incentive"
                  background-color="white"
                  :error="errors.has('Incentive')"
                  v-validate="'decimal:4|min_value:0'"
                />
              </v-flex>

              <v-flex xs4 pa-2>
                <v-text-field
                  v-model.number="form.month_cut"
                  :label="$t('Cut')"
                  hide-details
                  box
                  data-vv-name="Cut"
                  background-color="white"
                  :error="errors.has('Cut')"
                  v-validate="'decimal:4|min_value:0'"
                />
              </v-flex>

              <v-flex xs12 pa-2>
                <v-textarea
                  v-model="form.note"
                  :label="$t('Note')"
                  name="note"
                  hide-details
                  box
                  height="80"
                  background-color="white"
                />
              </v-flex>
            </v-layout>
          </v-layout>
        </v-card-title>
        <v-divider light />

        <v-card-actions class="grey lighten-3">
          <v-layout column>
            <v-flex xs12 class="pb-2 px-2" style="color: #444;"
              >- {{ $t('Fields marked with asterisk ( * ) are required.') }}</v-flex
            >

            <v-layout justify-end align-center pr-2 pl-2>
              <v-checkbox color="primary" v-model="keepForm" :label="$t('Keep this form to add another one.')" />

              <v-btn outline color="primary" @click="$emit('hidemodal')">{{ $t('Cancel') }}</v-btn>
              <v-btn type="submit" color="success" :loading="btnAddLoading">
                <v-icon :right="$vuetify.rtl" :left="!$vuetify.rtl">save</v-icon>
                {{ $t('Add') }}
              </v-btn>
            </v-layout>
          </v-layout>
        </v-card-actions>
      </form>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import * as helpers from '@/mixins/helperFunctions.js'

export default {
  name: 'add-component',

  props: {
    addDialog: { type: Boolean, required: true }
  },

  data() {
    return {
      btnAddLoading: false,
      form: {
        month_incentive: 0,
        month_cut: 0,
        the_month: ''
      },
      dateModal: false,
      keepForm: false
    }
  },

  computed: {
    theDate() {
      if (!this.form.the_month) {
        return ''
      }
      return helpers.formatDateAsMonthYear(this.form.the_month)
    }
  },

  watch: {
    addDialog: {
      immediate: false,
      handler() {
        if (this.addDialog) {
          this.addEscKeyListener()
          this.resetForm()
          this.keepForm = false
        }
      }
    }
  },

  methods: {
    ...mapActions({
      addPayroll: 'payrolls/addPayroll'
    }),

    addEscKeyListener() {
      document.addEventListener('keyup', e => {
        // if the "ESC" button was pressed and this dialog is shown, hide it
        if (e.keyCode === 27 && this.addDialog) {
          this.$emit('hidemodal')
        }
      })
    },

    resetForm() {
      this.$validator.pause()
      for (let key in this.form) {
        this.form[`${key}`] = null
      }
      this.form.the_month = this.$moment()
        .format()
        .substr(0, 10)
      this.form.month_incentive = 0
      this.form.month_cut = 0
      this.$nextTick(() => {
        this.$validator.resume()
        // default veutify autofocus only one time works so we have to handled in this way.
        // document.getElementById('payroll-focus-me').focus()
      })
    },

    validateBeforeSubmit() {
      this.$validator
        .validateAll()
        .then(() => {
          if (!this.errors.any()) {
            this.btnAddLoading = true
            this.form.payroll_month = helpers.formatDateAsMonthYear(this.form.the_month)

            if (this.form.month_incentive < 1) {
              this.form.month_incentive = 0
            }
            if (this.form.month_cut < 1) {
              this.form.month_cut = 0
            }

            this.addPayroll(this.form)
              .then(() => {
                this.btnAddLoading = false
                this.$emit('reset-datatable')
                if (this.keepForm) {
                  this.resetForm()
                } else {
                  this.$emit('hidemodal')
                }
              })
              .catch(() => {
                this.btnAddLoading = false
              })
          }
        })
        .catch(() => {
          this.btnAddLoading = false
        })
    }
  }
}
</script>

<style scoped></style>
